<template>
  <aside v-if="!checkingAuth && !isAuthenticated" class="promo-card">
    <p class="promo-kicker">Full Access Requires Premium Account</p>
    <h2>Subscribe for Full Access</h2>
    <p class="teaser-text">
      Unlock the full data experience with premium sportsbook odds, prediction-market activity,
      team context, and deeper game detail.
    </p>
    <div class="promo-actions">
      <router-link to="/register" class="promo-download">Start 7-Day Free Trial</router-link>
    </div>
  </aside>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { auth } from '@/lib/supabase'

const checkingAuth = ref(true)
const isAuthenticated = ref(false)
let authSubscription = null

onMounted(async () => {
  try {
    const { session } = await auth.getSession()
    isAuthenticated.value = Boolean(session)

    const { data } = auth.onAuthStateChange((_event, session) => {
      isAuthenticated.value = Boolean(session)
    })

    authSubscription = data?.subscription
  } catch (error) {
    console.error('Promo auth check error:', error)
    isAuthenticated.value = false
  } finally {
    checkingAuth.value = false
  }
})

onUnmounted(() => {
  authSubscription?.unsubscribe()
})
</script>

<style scoped>
.promo-card {
  margin: 0;
  overflow: hidden;
  border: 1px solid rgba(91, 124, 255, 0.38);
  border-radius: 10px;
  background:
    radial-gradient(circle at 92% 0%, rgba(155, 174, 255, 0.28), transparent 34%),
    linear-gradient(135deg, rgba(91, 124, 255, 0.38), rgba(8, 8, 8, 0) 48%),
    linear-gradient(180deg, #111111, #050505),
    #080808;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 16px 34px rgba(12, 12, 10, 0.14);
  padding: 1rem;
}

.promo-kicker {
  margin: 0 0 0.4rem;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.62rem;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.promo-card h2 {
  margin: 0;
  color: #ffffff;
  font-size: 1.06rem;
  letter-spacing: 0;
}

.teaser-text {
  margin: 0.45rem 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.82rem;
  line-height: 1.45;
}

.promo-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
  justify-content: stretch;
  margin-top: 0.86rem;
}

.promo-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 36px;
  padding: 0.48rem 0.76rem;
  font-size: 0.82rem;
  font-weight: 850;
  line-height: 1;
  text-decoration: none;
}

.promo-download {
  border: 1px solid rgba(255, 255, 255, 0.96);
  border-radius: 7px;
  background: linear-gradient(180deg, #ffffff, #eef1ff);
  color: #080808;
  box-shadow: 0 10px 22px rgba(91, 124, 255, 0.18);
}

.promo-download:hover {
  background: #ffffff;
  border-color: #ffffff;
}
</style>
